import {
  IndicatorBadge,
  IndicatorBadgeSizes,
  IndicatorBadgeVariants,
  LPSettlementBatchSourceEnum,
  Tooltip,
} from '@talos/kyoko';

export interface ManualSettlementBadgeProps {
  /** WebSocket `CreationSource` or grid row `BatchCreationSource`. */
  creationSource: LPSettlementBatchSourceEnum | undefined;
}

export function ManualSettlementBadge({ creationSource }: ManualSettlementBadgeProps) {
  if (creationSource !== LPSettlementBatchSourceEnum.Manual) {
    return null;
  }

  return (
    <Tooltip tooltip="Manual Settlement">
      <IndicatorBadge
        title="Manual Settlement"
        size={IndicatorBadgeSizes.Compact}
        variant={IndicatorBadgeVariants.Information}
        cursor="default"
      >
        M
      </IndicatorBadge>
    </Tooltip>
  );
}
